import React from "react";
import { Medal } from "lucide-react";
import { goalStreakWeeks, goalBadge, nextGoalTier } from "../lib/goalStreak";

// Goal-streak badge (Bronze 4 / Silver 8 / Gold 12 consecutive weeks hitting the weekly goal).
const GoalBadge = ({ child, size = "sm", showProgress = false }) => {
  if (!child?.weeklyGoal) return null;
  const weeks = goalStreakWeeks(child.stepLog, child.weeklyGoal);
  const badge = goalBadge(weeks);
  const next = nextGoalTier(weeks);
  if (!badge && !showProgress) return null;
  const big = size === "lg";
  return (
    <div className="inline-flex flex-col items-start gap-1" data-testid={`goal-badge-${child.id}`} data-tier={badge?.tier || "none"} data-weeks={weeks}>
      {badge ? (
        <span className={`inline-flex items-center gap-1.5 rounded-full font-bold ${big ? "px-4 py-2 text-sm" : "px-2.5 py-1 text-xs"}`} style={{ background: badge.bg, color: badge.color, border: `2px solid ${badge.color}` }} title={`${weeks} weeks in a row hitting the weekly goal`}>
          <Medal size={big ? 18 : 14} /> {badge.label} goal streak · {weeks}w
        </span>
      ) : (
        <span className={`inline-flex items-center gap-1.5 rounded-full font-bold bg-[#f7fdfe] text-[#0c4a6e] border-2 border-dashed border-[#c9ecf5] ${big ? "px-4 py-2 text-sm" : "px-2.5 py-1 text-xs"}`}>
          <Medal size={big ? 18 : 14} className="text-gray-400" /> {weeks} of {next.minWeeks} weeks to {next.label}
        </span>
      )}
      {showProgress && badge && next && <span className="text-[11px] text-gray-500 pl-1">{next.minWeeks - weeks} more week{next.minWeeks - weeks === 1 ? "" : "s"} to {next.label}</span>}
    </div>
  );
};

export default GoalBadge;
